import React, { useState, useEffect, useRef } from 'react';
import { ListGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { getSessionComponentsPretty } from '../../redux/slice/tanProfileSlice';
import NavigationWrapper from '../../components/sessionNavigation/navigationWrapper';
import CenteredToast from '../../components/centeredToast/centeredToast';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { useSaveSessionProfileMutation, useSaveExistingSessionProfileMutation } from '../../redux/services/tanProfilesApi';
import { useSetSessionMutation, useModifyComponentsMutation } from '../../redux/services/sessionApi';
import "./confirmSelection.css"
import { useTranslation } from 'react-i18next';
import { clearModRes } from '../../redux/slice/sessionSlice';
import { setProfileMeta, setSelected } from '../../redux/slice/tanProfileSlice';
import { persistor } from '../../redux/store/store';
import { useNavigate } from 'react-router-dom';
import { useNavigationManager } from '../../logic/nextNav';
const ConfirmSelection = () => {
    const dispatch = useDispatch()
    const items = useSelector(getSessionComponentsPretty)
    const [showAlert, setShowAlert] = useState(false)
    // const [triggerNavigate, setTriggerNavigate] = useState()
    const { currentIndex, prevIndex, navigate, sessionSelection } = useNavigationManager();
    const selectedProfile = useSelector((state) => state?.tanProfile?.selectedProfile)
    const tanProfile = useSelector((state) => state?.tanProfile)
    const session = useSelector((state) => state?.session);
    const auth = useSelector((state) => state?.auth);
    const [profileName, setProfileName] = useState(selectedProfile?.session_name || "")
    const [saveSessionProfile, { isLoading, isSuccess, isError }] = useSaveSessionProfileMutation();
    const [setSession, { isLoading: settingSession, isSuccess: sessionSetSuccess, isError: sessionSetError }] = useSetSessionMutation();
    const [modifyComponents, { isSuccess: modifiedComps, data: compData }] = useModifyComponentsMutation();
    const [saveExistingSessionProfile] = useSaveExistingSessionProfileMutation(); // RTK Query mutation hook
    const { t } = useTranslation("translation", { keyPrefix: "confirmSelection" });
    const letsGo = useNavigate()
    let total = 0

    const runSetSession = async () => {
        try {
            if (!session?.confirmedSession) {
                let data = await setSession({
                    "booth_id": tanProfile?.scannedBoothData?.id,
                    "user_id": auth?.user?.id,
                    "lock_id": session?.session?.sid,
                    "source": "mobile_app",
                    "session_price": total
                }).unwrap()
                console.log(data)
                let newArray = tanProfile?.selectedProfile?.session_component.map(item => ({ ...item, value: parseInt(item.value) || 1, session_id: data?.payload?.id }))
                await modifyComponents(newArray).unwrap()
                navigate(true)
            } else {
                let newArray = tanProfile?.selectedProfile?.session_component.map(item => ({ ...item, value: parseInt(item.value) || 1, session_id: session?.confirmedSession?.id }))
                await modifyComponents(newArray).unwrap()
                navigate(true)
            }
        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        console.log(session?.componentsModRes)
        if (session?.componentsModRes) {
            navigate(true)
            dispatch(clearModRes())
        }
        // prevSave.current = session?.componentsModRes?.sessionComponent[0]?.updated_at
    }, [session?.componentsModRes]);
    // useEffect(() => {
    //     console.log(triggerNavigate)
    // }, [triggerNavigate]);

    const setSessionOrNavigate = () => {
        if (tanProfile.scannedBoothData) {
            runSetSession()
        } else {
            dispatch(setProfileMeta({ options: [], navigationDirection: "" }));
            dispatch(setSelected({ session_component: [] }))
            letsGo("/tanProfiles")
        }
    }

    const handleSaveClick = async () => {
        if (profileName.length > 0) {
            if (selectedProfile?.id) {
                try {
                    const response = await saveExistingSessionProfile({
                        session_images: [{}],
                        session_name: profileName,
                        session_components: selectedProfile?.session_component,
                        id: selectedProfile.id

                    }).unwrap(() => { });
                    console.log('Profile saved successfully:', response);
                    setSessionOrNavigate()
                    // setTriggerNavigate("next") // hope it saved properly
                } catch (error) {
                    console.error('Failed to save profile:', error);
                    setShowAlert({alert: "error", msg: error?.data?.msg || "Unknown error occurred"})
                }
            } else {
                try {
                    const response = await saveSessionProfile({
                        session_images: [{}],
                        session_name: profileName,
                        session_components: selectedProfile?.session_component

                    }).unwrap(() => { });
                    console.log('Profile saved successfully:', response);
                    // setTriggerNavigate("next") // hope it saved properly
                    setSessionOrNavigate()
                } catch (error) {
                    console.error('Failed to save profile:', error);
                    setShowAlert({alert: "error", msg: error?.data?.msg || "Unknown error occurred"})
                }
            }
        } else {
            //boy should there be better validation responses huh
        }
    };

    const AlertOptions = ({ option }) => {
        switch (option.alert) {
            case "error":
                return (<CenteredToast
                    show={showAlert}
                    // onHide={(() => { setShowAlert(false) })}
                    onAccept={() => { setShowAlert("save") }}
                    hideCancelButton={!tanProfile.scannedBoothData}
                    onCancel={() => {
                        // console.log(session)
                        if (tanProfile.scannedBoothData) {
                            runSetSession()
                        }
                        // setTriggerNavigate("next")
                    }}
                    title={t("alertError", "Error")}
                    body={t("alertErrorBod", "Error occured.")}
                    acceptButtonText={t("errorAlertButton", "Okay")}
                    closeOnOverlayClick={false}
                >
                    <InputGroup className="mb-3">
                        {option.msg}
                    </InputGroup>
                </CenteredToast>)
            default:
            case "save":
                return (<CenteredToast
                    show={showAlert}
                    onHide={(() => { setShowAlert(false) })}
                    onAccept={() => { handleSaveClick() }}
                    hideCancelButton={!tanProfile.scannedBoothData}
                    onCancel={() => {
                        // console.log(session)
                        if (tanProfile.scannedBoothData) {
                            runSetSession()
                        }
                        // setTriggerNavigate("next")
                    }}
                    title={t("alert.title", "Save Profile")}
                    body={t("alert.body", "Would you like to save your session profile?")}
                    acceptButtonText={t("alert.button", "Save")}
                    cancelButtonText={t("alert.cancelButton", "Skip")}
                    closeOnOverlayClick={false}
                >
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">{t("alert.inputTitle", "Profile Name")}</InputGroup.Text>
                        <Form.Control
                            placeholder={t("alert.placeholder", "Profile Name")}
                            aria-label={t("alert.label", "Profile Name")}
                            aria-describedby="basic-addon1"
                            value={profileName}
                            onChange={(data) => setProfileName(data.target.value)}
                        />
                    </InputGroup>
                </CenteredToast>)
        }
    }

    return (
        <NavigationWrapper preventProceed={true} onNext={() => { setShowAlert({alert: "save"}) }} finalize={() => dispatch(clearModRes())}>

            <div className='session-header'>
                {t("title", "Review your session")}
            </div>
            <div>
                {/* <span style={{backgroundColor: "black",width: '20px',height: '20px',borderRadius: '50%',display: 'inline-block',marginRight: '10px'}}></span> 
                    <div className='itemLine'>
                        <div className='textLine'>{t("list.solution", "Solution")}</div>
                        <div className='textLine'>{t("list.selection", "Selection")}</div>
                        {tanProfile.scannedBoothComponents ? <div className='textLine'>{t("list.price", "Price")}</div> : null}
                    </div> */}
                {items.map((item, index) => {
                    let line = ""
                    switch(item.name.toLowerCase()){
                        case "scents":
                        case "scent":
                            line = item.value + (item.count > 1 ? ' x2' : '')
                            break;
                        case "bronzers":
                        case "bronzer":
                            line = item.value + " Bronzer" + (item.count > 1 ? ' x2' : '')
                            break;
                        case "base tan level":
                        case "tan":
                        case "base":
                        case "rapid":
                            let shadeText = parseInt(item.value) > 12 ? item.name : "spray shade: " + item.value;
                            line = shadeText;
                            break;
                        case 'wellfit': 
                            line = item.name + " " + item.value
                            break;
                        default:
                            line = item.name
                    }
                    return <>
                        <div className='itemLine'>
                            <div className='textLine'>{line}</div>
                            {tanProfile.scannedBoothComponents ?
                                <div className='textLine' style={{marginLeft:"4px"}}>${(() => {
                                    //Don't you dare judge me
                                    let salonData = tanProfile.scannedBoothComponents.find((comp) => comp.id === item.component_id)?.component_values.find((cVal) => cVal.id === item.id)

                                    let price = salonData?.booth_component_pricing[0] ? salonData?.booth_component_pricing[0]?.msrp : salonData?.price 
                                    //This should pull salon pricing when it's available. I've seen it not exist and  I don't know why but it should revert to admin portal pricing on this line
                                    total += price
                                    return price
                                })()}</div> : null}
                        </div>
                    </>
                })}
                {tanProfile.scannedBoothComponents ?
                    <div>
                        <div className='itemLine' style={{ "font-weight": "bold" }}>
                            {/* <div className='textLine'></div> */}
                            <div className='textLine'>{t("list.total", "Total:")}</div>
                            <div className='textLine'>{t("list.totalNumber", "${{price}}", { price: total })}</div>
                        </div>
                    </div> :
                    null}
            </div>
            {showAlert && AlertOptions({ option: showAlert })}

        </NavigationWrapper>
    );
};

export default ConfirmSelection;